// src/services/servicos/TecnicoResponsavelService.js
import { deleteData, fetchData, postData, putData } from '../Api';

export const listarTecnicosResponsaveis = () => fetchData('/TecnicoResponsavel');
export const obterTecnicoResponsavel = id => fetchData(`/TecnicoResponsavel/${id}`);
export const criarTecnicoResponsavel = tecnico => postData('/TecnicoResponsavel', tecnico);
export const atualizarTecnicoResponsavel = tecnico => (
  putData(`/TecnicoResponsavel/${tecnico.id}`, tecnico)
);
export const excluirTecnicoResponsavel = id => deleteData(`/TecnicoResponsavel/${id}`);
